export default "__VITE_ASSET__f5c26e3f__"